import script from "./BillingDataPaid.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillingDataPaid.vue?vue&type=script&setup=true&lang=ts"

import "./BillingDataPaid.vue?vue&type=style&index=0&id=328da31d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-328da31d"]])

export default __exports__